export default [
  // Router nhập số dư ban đầu
  {
    path: 'account-balance/:key?',
    name: 'account-balance',
    component: () => import('@/views/accountBalance/AccountBalanceIndex.vue'),
    meta: {},
  },
  // Router định dạng số
  {
    path: '/format-number',
    name: 'format-number',
    component: () => import('@/views/formatNumber/FormatNumber.vue'),
    meta: {},
  },
];
